import {User} from "../api-client/AppFwApiClient.ts";

export function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
}

export function stringAvatarForUser(user: User) {
    return stringAvatar(user.name ?? user.id)
}

export function stringAvatar(name: string) {
    let initials: string
    if (name.indexOf("@") > 0) {
        initials = initialsFromEmail(name)
    } else {
        initials = initialsFromName(name)
    }
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: initials,
    };
}

const firstChar = (s: string) => (s.match(/[\p{L}\p{N}]/u) ?? [""])[0];

export function initialsFromName(name: string, locale = "de-DE"): string {
    const parts = name.trim().split(/[\s\-]+/).filter(Boolean); // Wörter & Bindestriche
    if (parts.length >= 2) {
        return (firstChar(parts[0]) + firstChar(parts[parts.length - 1]))
            .toLocaleUpperCase(locale);
    }
    if (parts.length === 1) {
        const chars = parts[0].match(/[\p{L}\p{N}]/gu) ?? [];
        const two = (chars[0] ?? "") + (chars[1] ?? "");
        return (two || "?").toLocaleUpperCase(locale);
    }
    return "?";
}

export function initialsFromEmail(email: string, locale = "de-DE"): string {
    const localPart = (email || "").split("@")[0] ?? "";
    const tokens = localPart
        .split(/[.\-_+]+/g)
        .map(t => t.trim())
        .filter(Boolean);

    if (tokens.length >= 2) {
        return (firstChar(tokens[0]) + firstChar(tokens[tokens.length - 1]))
            .toLocaleUpperCase(locale);
    }
    if (tokens.length === 1) {
        const chars = tokens[0].match(/[\p{L}\p{N}]/gu) ?? [];
        const two = (chars[0] ?? "") + (chars[1] ?? "");
        return (two || firstChar(localPart) || "?").toLocaleUpperCase(locale);
    }
    return (firstChar(localPart) || "?").toLocaleUpperCase(locale);
}
